import { FilterQuery } from '@yes.technology/react-toolkit'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { useSiteState } from 'siteState/shared'
import useBoundFilterQueryElementUuid from 'siteState/shared/hooks/useBoundFilterQueryElementUuid'
import NavigationSlider from '../NavigationSlider/NavigationSlider'
import { defaultEventsProjectFileds, defaultPageSizeByDevice } from './contants'
import { Container } from './EventCardContainer.styles'
import { EventCardContainerProps } from './EventCardContainer.types'
import EventsGrid from './EventsGrid'
import useMonthsNavigation from './hooks/useMonthsNavigation'
import usePaginatedMonthlyEvents from './hooks/usePaginatedMonthlyEvents'
import useStartDateWithAvailableEvents from './hooks/useStartDateWithAvailableEvents'

const EventCardContainer = ({ props }: EventCardContainerProps) => {
  const {
    elementUuid,
    uuid_objectclass: objectclassUuid,
    styleMap,
    project_fields: projectFields = defaultEventsProjectFileds,
    page_size_by_device: pageSizeByDevice = defaultPageSizeByDevice,
    months_navigation_styleMap: monthsNavigationStyleMap = {},
    events_navigation_styleMap: eventsNavigationStyleMap = {},
    filterquery = {},
    isolate_filter_query: isolateFilterQuery = false,
    orderby = [
      {
        start_date: 'asc'
      }
    ],
    card_variant: cardVariant = 'list'
  } = props

  const style = useStyleMaps(styleMap)

  const boundFilterQueryElementUuid = useBoundFilterQueryElementUuid(
    elementUuid,
    isolateFilterQuery
  )

  const [filterFieldsFilterQuery] = useSiteState<FilterQuery>(
    'filter-query',
    boundFilterQueryElementUuid
  )

  const { startDate, isLoading: isLoadingStartDate } =
    useStartDateWithAvailableEvents({
      filterquery,
      filterFieldsFilterQuery,
      objectclassUuid
    })

  const {
    navigation: currentMonthNavigation,
    isLoading: isMonthyNavigationLoading
  } = useMonthsNavigation({
    startDate,
    filterquery,
    filterFieldsFilterQuery,
    objectclassUuid
  })

  const {
    data: events,
    isLoading: isLoadingEvents,
    navigation: eventsNavigation,
    shouldDisplayPagination
  } = usePaginatedMonthlyEvents({
    elementUuid,
    startDate: currentMonthNavigation?.date,
    filterquery,
    filterFieldsFilterQuery,
    objectclassUuid,
    projectFields,
    pageSizeByDevice,
    orderby
  })

  const isLoading =
    isLoadingStartDate || isMonthyNavigationLoading || isLoadingEvents

  return (
    <Container style={style}>
      {currentMonthNavigation && (
        <NavigationSlider
          {...currentMonthNavigation}
          disabled={currentMonthNavigation.disabled || isLoading}
          currentIndex={0}
          styleMap={monthsNavigationStyleMap}
        />
      )}

      {shouldDisplayPagination && (
        <NavigationSlider
          {...eventsNavigation}
          styleMap={eventsNavigationStyleMap}
        />
      )}

      <EventsGrid
        events={events}
        isLoading={isLoadingEvents}
        cardVariant={cardVariant}
      />
    </Container>
  )
}

export default EventCardContainer
